// extracted by mini-css-extract-plugin
module.exports = {"b1kts399":"b1kts399","t1ympz1x":"t1ympz1x"};